module.exports = __webpack_public_path__ + "static/media/loc2_img11.2dcc6ed5.jpg";